function getFirebaseCode(error: unknown): string | null {
  if (typeof error !== "object" || error === null) return null;
  const code = (error as { code?: unknown }).code;
  return typeof code === "string" ? code : null;
}

export function getFirebasePhoneAuthMessage(error: unknown): string {
  const code = getFirebaseCode(error);
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : String(error ?? "");
  switch (code) {
    case "auth/invalid-phone-number":
      return "Invalid phone number. Use E.164 format (e.g. +919876543210).";
    case "auth/too-many-requests":
      return "Too many attempts. Please wait a bit and try again.";
    case "auth/invalid-verification-code":
      return "Invalid OTP code. Please check and try again.";
    case "auth/code-expired":
    case "auth/session-expired":
      return "This OTP has expired. Please request a new OTP.";
    case "auth/captcha-check-failed":
      return "reCAPTCHA verification failed. Please try again.";
    case "auth/invalid-app-credential":
      return "Phone verification failed due to an invalid app credential. Refresh and try again. If it persists, verify Firebase Auth authorized domains and reCAPTCHA configuration.";
    case "auth/credential-already-in-use":
      return "This phone number is already linked to another account.";
    default:
      if (message.includes("INVALID_APP_CREDENTIAL")) {
        return "Phone verification failed due to an invalid app credential. Refresh and try again. If it persists, verify Firebase Auth authorized domains and reCAPTCHA configuration.";
      }
      if (message.trim().length > 0) {
        return message;
      }
      return "Phone authentication failed. Please try again.";
  }
}

export function getFirebaseGoogleAuthMessage(error: unknown): string {
  const code = getFirebaseCode(error);
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : String(error ?? "");
  switch (code) {
    case "auth/popup-closed-by-user":
      return "Google sign-in was cancelled.";
    case "auth/popup-blocked":
      return "Popup was blocked by the browser. Please allow popups and try again.";
    case "auth/account-exists-with-different-credential":
      return "An account already exists with this email using a different sign-in method.";
    case "auth/unauthorized-domain":
      return "This domain is not authorized for Google sign-in in Firebase settings.";
    default:
      if (message.trim().length > 0) {
        return message;
      }
      return "Google sign-in failed. Please try again.";
  }
}
